import { HotelBathFurniture, HotelInfoModel } from '@/__generated';
import React from 'react';
import { HotelBathEquipment } from '../type';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  hotelInfo: HotelInfoModel;
};

export default function Spa({ hotelInfo }: Props) {
  const getServices = (equipments: HotelBathFurniture[]) => {
    return equipments.map(e => {
      let icon = HotelBathEquipment[e.name || '']?.icon;
      if (icon) {
        return {
          name: `${e.name}` + e.isFree ? '[free]' : ['with charge'],
          icon: icon,
        };
      }
      return {
        name: `${e.name}` + e.isFree ? '[free]' : ['with charge'],
        icon: 'ficon-confirmation-instant',
      };
    });
  };
  if (!hotelInfo.hotelBaths?.length) {
    return null;
  }
  return (
    <div id="spa" className="row y-gap-40 pt-20 pb-20">
      <div className="col-12">
        <h3 className="text-22 fw-500 pt-30 border-top-light">Spa (Onsen/ Public bath)</h3>
        <div className="row x-gap-10 y-gap-10 mt-20">
          {hotelInfo.hotelBaths?.map(bath => {
            return (
              <div className="col-md-6 col-xs-12" key={bath.code}>
                <div className="p-4 rounded text-15 h-100" style={{ backgroundColor: '#f0f8ff' }}>
                  <div className="d-md-flex ">
                    <div>
                      <i className="ficon ficon-private-bath mr-5" />
                      Bath type:
                    </div>
                    <div className="fw-500 flex-grow-1 text-end"> {bath.type}</div>
                  </div>
                  <div className="d-md-flex ">
                    <div>
                      <i className="ficon ficon-after-hours mr-5" />
                      Opening hours:
                    </div>
                    <div className="fw-500 flex-grow-1 text-end"> {bath.usingTime?.normalize('NFKC')}</div>
                  </div>
                  <div className="row x-gap-10 y-gap-10">
                    {bath.gender ? (
                      <div className="col-md-4  col-xs-12">
                        <div className="d-flex">
                          <div>
                            <i className="ficon ficon-regular-gender mr-5" />
                            Gender:
                          </div>
                          <div className="fw-500 pl-5"> {bath.gender}</div>
                        </div>
                      </div>
                    ) : null}

                    {bath.capacity ? (
                      <div className="col-md-4  col-xs-12 d-flex">
                        <div>
                          <i className="ficon ficon-regular-capacity mr-5" />
                          Capacity:
                        </div>
                        <div className="fw-500 pl-5">{bath.capacity} people</div>
                      </div>
                    ) : null}

                    <div className="col-md-4  col-xs-12 d-flex">
                      <div>
                        <i className="ficon ficon-spoken-24 mr-5" />
                        Use for 24 hours:
                      </div>
                      {bath.allTimeAvailable === false ? (
                        <div className="fw-500 pl-5">
                          <span className="text-success text-16">Yes</span>
                        </div>
                      ) : (
                        <div className="fw-500 pl-5 text-16 text-red-1">
                          <FontAwesomeIcon icon={faBan} className="mr-5" />
                        </div>
                      )}
                    </div>
                  </div>
                  {bath.hasSpa || bath.hasSauna || bath.hasJacuzzi ? (
                    <div className="row x-gap-10 y-gap-10">
                      <div className="col-12 fw-500 text-15 ">Equipment</div>
                      {bath.hasSpa ? (
                        <div className="col-3">
                          <i className="pr-5 ficon ficon-spas" />
                          Spa
                        </div>
                      ) : null}
                      {bath.hasSauna ? (
                        <div className="col-3">
                          <i className="pr-5 ficon ficon-sauna" />
                          Sauna
                        </div>
                      ) : null}
                      {bath.hasJacuzzi ? (
                        <div className="col-3">
                          <i className="pr-5 ficon ficon-jacuzzi-bathtub" />
                          Jacuzzi
                        </div>
                      ) : null}
                    </div>
                  ) : null}

                  <div className="row x-gap-10">
                    {getServices(bath.furniture || []).map(service => {
                      return (
                        <div className="col-3">
                          <i className={`pr-5 ficon ${service.icon}`} />
                          {service.name}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
